/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.chat.pinnedRecord";

export { $nsid };

/** Record pinning a chat message for prominent display. */
type Main = { $type: "place.stream.chat.pinnedRecord";

  /**
   * AT-URI of the pinned chat message.
   */
  "pinnedMessage":l.AtUriString;

  /**
   * DID of the user who pinned the message.
   */
  "pinnedBy"?:l.DidString;

  /**
   * When this pin was created.
   */
  "createdAt":l.DatetimeString;

  /**
   * Optional expiration time. If set, the pin is considered inactive after this time.
   */
  "expiresAt"?:l.DatetimeString };

export type { Main };

/** Record pinning a chat message for prominent display. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"pinnedMessage":/*#__PURE__*/ l.string({"format":"at-uri"}),"pinnedBy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"expiresAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
